var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22.75,
    viewBox: "0 0 28 22.75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71661 9.90769L18.3953 3.1551C20.0417 2.45171 25.6251 0.200844 25.6251 0.200844C25.6251 0.200844 28.202 -0.783908 27.9873 1.60763C27.9157 2.59239 27.343 6.03902 26.7704 9.76701L24.9808 20.8103C24.9808 20.8103 24.8377 22.4281 23.6208 22.7095C22.4039 22.9908 20.3996 21.7247 20.0417 21.4434C19.7553 21.2324 14.673 18.0671 12.8119 16.5196C12.3108 16.0976 11.7381 15.2535 12.8834 14.2687C15.4604 11.9475 18.5384 9.06362 20.3996 7.23479C21.2586 6.39072 22.1175 4.42121 18.5384 6.81276L8.44534 13.495C8.44534 13.495 7.30002 14.1984 5.15256 13.5653C3.00509 12.9323 0.499711 12.0882 0.499711 12.0882C0.499711 12.0882 -1.21826 11.0331 1.71661 9.90769V9.90769Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bd1e350bd445a75c4c91dae673dcfb77.svg";
export { ForwardRef as ReactComponent };